import { render, staticRenderFns } from "./merchantCouponSaleRecord.vue?vue&type=template&id=b9d34d56&scoped=true"
import script from "./merchantCouponSaleRecord.vue?vue&type=script&lang=ts"
export * from "./merchantCouponSaleRecord.vue?vue&type=script&lang=ts"
import style0 from "./merchantCouponSaleRecord.vue?vue&type=style&index=0&id=b9d34d56&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d34d56",
  null
  
)

export default component.exports